import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CSSelectComponent } from 'src/app/shared/components/cs-select/cs-select.component';
import { SelectLangDialogComponent } from 'src/app/shared/components/dialogs/select-lang-dialog/select-lang-dialog.component';
import { PipesModule } from 'src/app/shared/pipes/pipes.module';
import { FooterComponent } from './footer.component';

@NgModule({
  imports: [CommonModule, PipesModule, CSSelectComponent],
  declarations: [FooterComponent, SelectLangDialogComponent],
  exports: [FooterComponent],
})
export class FooterModule {}
